<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <InformacionGeneralEvaluacionSection :evaluacion="evaluacion" />
      </v-col>
      <v-col cols="12">
        <ReactivosEvaluacionSection :evaluacion="evaluacion" :reactivos="reactivos" />
      </v-col>
      <v-col cols="12">
        <ResultadoEvaluacionSection :evaluacion="evaluacion" />
      </v-col>
      <v-col cols="12" align="center">
        <v-btn class="ui-module-btn-solid" @click="updateEvaluacion()" :loading="loading">Guardar evaluación</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UpdateRespetoValoresPrincipios from '@/modules/respeto-valores-principios/application/UpdateRespetoValoresPrincipios.usecase'
import _ from 'lodash'
import { mapGetters, mapMutations } from 'vuex'
import { ACADEMIC_PERFORMANCE_EVALUATION_TYPES } from '../../../../modules/evaluacion-desempeño-academico/domain/entities/Evaluation'
import InformacionGeneralEvaluacionSection from '../sections/InformacionGeneralEvaluacionSection.vue'
import ReactivosEvaluacionSection from '../sections/ReactivosEvaluacionSection.vue'
import ResultadoEvaluacionSection from '../sections/ResultadoEvaluacionSection.vue'
import RespetoValoresPrincipiosApiRepository from '@/modules/respeto-valores-principios/infrastructure/RespetoValoresPrincipiosApi.repository'
import {
  getCalification,
  getIdResultado,
  getPuntajeTotal,
} from '@/modules/evaluacion-desempeño-academico/domain/rules/evaluation.rules'
import RendimientoProfesionalismoApiRepository from '@/modules/rendimiento-profesionalismo/infrastructure/RendimientoProfesionalismoApi.repository'
import UpdateRendimientoProfesionalismo from '@/modules/rendimiento-profesionalismo/application/UpdateRendimientoProfesionalismo.usecase'
import DesempeñoInstitucionalApiRepository from '@/modules/desempeño-institucional/infrastructure/DesempeñoInstitucionalApi.repository'
import UpdateDesempeñoInstitucional from '@/modules/desempeño-institucional/application/UpdateDesempeñoInstitucional.usecase'

export default {
  components: {
    InformacionGeneralEvaluacionSection,
    ReactivosEvaluacionSection,
    ResultadoEvaluacionSection,
  },

  data() {
    return {
      loading: false,
      evaluacion: _.cloneDeep(this.$store.getters['evaluacionesPersonal/getSelectedEvaluation']),
    }
  },

  computed: {
    ...mapGetters('reactivoValor', {
      catalogoReactivos: 'getReactivoValor',
    }),

    ...mapGetters('reactivosEvaluacion', {
      reactivosRendimientoProfesionalismo: 'getReactivosRendimientoProfesionalismo',
      reactivosDesempenioInstitucional: 'getReactivosDesempenioInstitucional',
    }),

    reactivos() {
      switch (this.evaluacion.tipo) {
        case ACADEMIC_PERFORMANCE_EVALUATION_TYPES.RESPECT_VALUES_AND_PRINCIPLES:
          return this.catalogoReactivos
        case ACADEMIC_PERFORMANCE_EVALUATION_TYPES.PERFORMANCE_AND_PROFESSIONALISM:
          return this.reactivosRendimientoProfesionalismo
        case ACADEMIC_PERFORMANCE_EVALUATION_TYPES.INSTITUTIONAL_PERFORMANCE:
          return this.reactivosDesempenioInstitucional
        default:
          return []
      }
    },

    getPuntajeTotal: function () {
      return getPuntajeTotal(this.evaluacion.reactivos)
    },

    getCalificacion: function () {
      return getCalification(this.getPuntajeTotal, this.evaluacion.tipo)
    },

    getResultado: function () {
      return getIdResultado(this.getPuntajeTotal, this.evaluacion.tipo)
    },
  },

  methods: {
    ...mapMutations('dialog', ['CLOSE_DIALOG']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    async updateEvaluacion() {
      this.loading = true

      try {
        this.evaluacion.puntajeTotal = this.getPuntajeTotal
        this.evaluacion.calificacion = this.getCalificacion
        this.evaluacion.idResultado = this.getResultado

        switch (this.evaluacion.tipo) {
          case ACADEMIC_PERFORMANCE_EVALUATION_TYPES.RESPECT_VALUES_AND_PRINCIPLES:
            await new UpdateRespetoValoresPrincipios(new RespetoValoresPrincipiosApiRepository()).execute(
              this.evaluacion
            )
            break

          case ACADEMIC_PERFORMANCE_EVALUATION_TYPES.PERFORMANCE_AND_PROFESSIONALISM:
            await new UpdateRendimientoProfesionalismo(new RendimientoProfesionalismoApiRepository()).execute(
              this.evaluacion
            )
            break

          case ACADEMIC_PERFORMANCE_EVALUATION_TYPES.INSTITUTIONAL_PERFORMANCE:
            await new UpdateDesempeñoInstitucional(new DesempeñoInstitucionalApiRepository()).execute(this.evaluacion)
            break

          default:
            break
        }

        this.CLOSE_DIALOG()
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('Error al actualizar la evaluación.')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.ui-module-btn-solid {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  padding-left: 24px !important;
  padding-right: 24px !important;
  background: linear-gradient(135deg, var(--v-secondary-base) 0%, var(--v-secondary-lighten1) 100%) !important;
  color: #08130f !important;
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb), 0.28) !important;
  transition: all 0.3s ease;
}

.ui-module-btn-solid:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(var(--v-secondary-base-rgb), 0.25) !important;
}
</style>
